






import Component from 'vue-class-component';
import { sensorApi } from '@/context/sensor/api/SensorApi';
import { SensorFormModel } from '@/context/sensor/model/SensorFormModel';
import { FormContainer } from '@/common/mixin/FormContainer';
import SensorCreateForm from '@/context/sensor/component/form/SensorCreateForm.vue';

@Component({
  components: { SensorCreateForm }
})
export default class SensorCreateContainer extends FormContainer<SensorFormModel> {
  model: SensorFormModel = new SensorFormModel();

  async formApi(): Promise<SensorFormModel> {
    const response: SensorFormModel = await sensorApi.form<SensorFormModel>(SensorFormModel, null);
    return response;
  }
}
